import { Thread_Status_Enum } from '../gql'

export const threadStatusList = [
  Thread_Status_Enum.Preparation,
  Thread_Status_Enum.Active,
  Thread_Status_Enum.Blocked,
  Thread_Status_Enum.Closed,
]
